export default "__VITE_ASSET__Yq5cekOy__"